<template>
<v-dialog
      v-model="dialog"
      persistent
      max-width="75vw"
    >
      <v-card>
        <v-toolbar flat color="secondary">
          <v-toolbar-title class="white--text">
            Zone Detail
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon class="white--text" @click="closeModal">
              <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div>
          <v-container fluid>
            <div class="page-title">
             <h1>{{ zoneDetail.geofenceName }}</h1>
             <v-spacer></v-spacer>
              <v-btn color="red" dark outlined @click="deleteZone" class="mr-2">
                {{ $t('Delete') }}
              </v-btn>
              <v-btn outlined color="primary" dark @click="editZoneModal">
                {{ $t('Edit Zone') }}
              </v-btn>
            </div>
            <v-card class="mx-auto" outlined>
              <v-row style="height: 600px;">
                <v-col cols="3">
                  <v-list two-line class="ma-8">
                    <v-list-item-content class="mb-4">
                      <v-list-item-subtitle class="mb-2">Perimeter</v-list-item-subtitle>
                      <v-list-item-title class="text--disabled">{{zoneDetail.geofenceParameter}} M</v-list-item-title>
                    </v-list-item-content>
      
                    <v-divider></v-divider>
      
                    <v-list-item-content class="mb-4">
                      <v-list-item-subtitle class="mb-2">Area</v-list-item-subtitle>
                      <v-list-item-title class="text--disabled">{{ zoneDetail.geofenceArea + ' ' + (zoneDetail.areaUomId == 1 ? 'Acre' : 'Hectare') }}</v-list-item-title>
                    </v-list-item-content>
      
                    <v-divider></v-divider>
      
                    <v-list-item-content class="mb-4">
                      <v-list-item-subtitle class="mb-2">Number of Group</v-list-item-subtitle>
                      <v-list-item-title class="text--disabled">{{ this.groupCount }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </v-col>
      
                <v-col cols="9">
      
                  <div class="google-map" style="width:100%;height:560px" id="map" ref="googleMap"></div>
      
                </v-col>
              </v-row>
            </v-card>
      
            <v-toolbar class="bdr secondary2light my-8" :elevation="0" outlined>
              <v-toolbar-title class="grey--text text--darken-2" style="font-size: 18px">
                {{ $t("Group") }}
              </v-toolbar-title>
            </v-toolbar>
      
            <v-card elevation="10" class="px-5">
              <v-card-text>
                <v-data-table :headers="headers" :items="groupList" item-key="id" :items-per-page="10"
                  :hide-default-footer="true" :options.sync="tableOptions">
                  <template v-slot:top>
                    <div class="d-flex mt-5">
                      <v-text-field prepend-inner-icon="mdi-magnify" outlined height="5px" placeholder="Search" dense
                        v-model="search" class="shrink"></v-text-field>
                      <v-btn :disabled="search.length < 1" color="primary" height="40" width="40" max-width="40" outlined
                        class="ml-8">
                        <v-icon>mdi-filter-outline</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <div class="py-1 title">
                        {{
                        (tableOptions.page - 1) * tableOptions.limit + 1
                        }}
                        -
                        {{
                        tableOptions.page * tableOptions.limit -
                        (tableOptions.limit - groupCount)
                        }}
                        of {{ totalCount }}
                      </div>
                      <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page <= 1"
                        @click="pageChange(false)">
                        <v-icon dark> mdi-chevron-left </v-icon>
                      </v-btn>
                      <v-btn class="mx-2" fab small outlined color="primary" :disabled="(tableOptions.page - 1) * tableOptions.itemsPerPage +
                                count >=
                                totalCount
                                " 
                        @click="pageChange(true)">
                        <v-icon dark> mdi-chevron-right </v-icon>
                      </v-btn>
                      <v-btn class="mx-2" fab small outlined color="primary">
                        <v-icon dark>
                          mdi-cog-outline
                        </v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <template v-if="groupList?.length" v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td>{{ item.name }}</td>
                        <td>{{ item.animalCounts }}</td>
                        <td>{{ item.status }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
      
          </v-container>
        </div>        
      </v-card>
    </v-dialog>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import { Loader } from '@googlemaps/js-api-loader';
import FarmService from "@/_services/farmService";
import gql from 'graphql-tag';

export default {
  mixins: [loadingMixin],
    props: {
      dialog: {
        type: Boolean,
        required: true,
      },
        zoneDetail: {
            required: true,
        },
        locationId: {
          type: Number, 
          required: true,
        },
        farmId: {
          type: Number,
          require: true,
        }
    },
    apollo: {
        groups: {
            query: gql`query findGroupsByZoneId($zoneId: Int!, $search: String, $page: Int, $limit: Int) {
                findGroupsByZoneId(zoneId: $zoneId, search: $search, page: $page, limit: $limit) {
                  rows { 
                    id
                    animalCounts
                    name
                    status
                  }
                  totalCount
              }
            }`,
            variables() {
                return {
                  zoneId: parseInt(this.zoneDetail.id),
                    page: this.tableOptions.page,
                    limit: this.tableOptions.limit,
                    search: this.search
                }
            },
            result({ data }) {
              this.groupList = data.findGroupsByZoneId.rows;
              this.totalCount = data.findGroupsByZoneId.totalCount;
              this.groupCount = this.groupList.length;
            },
            fetchPolicy: 'network-only',
        }
    },
  data() {
    return {
      headers: [
        {
          text: "Group Name",
          align: "start",
          sortable: false,
          class: "black--text",
          value: "goal_name",
        },
        {
          text: "Number of Animals",
          value: "userFarmData",
          class: "black--text",
        },
        {
          text: "Status",
          value: "goalSubjectMapData[0].goalSubjectData.subject",
          class: "black--text",
        }
      ],
      mapOptions: {
        mapTypeId: 'satellite',
        center: {
          lat: -34.397,
          lng: 150.644
        },
        styles: {
          overflow: 'visible'
        },
        zoom: 18,
        disableDefaultUI: true,
      },
      oldSegments: [],
      orgFarm: {},
      to: '',
      from: '',
      tableOptions: { page: 1, limit: 10 },
      search: '',
      groupList: [],
      groupCount: 0,
      totalCount: 0,
    }
  },
  methods: {
    async initializeMap(google) {
      this.google = google;
      const mapContainer = this.$refs.googleMap
      this.map = await new google.maps.Map(mapContainer, this.mapOptions);

      this.polygon = new google.maps.Polygon({
        paths: this.parentPolygonCoords,
        strokeColor: "#00BD73",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FFF7EC",
        fillOpacity: 0.35,
      });

      this.polygon.setMap(this.map);

      if (this.oldSegments.length > 0) {
        this.oldSegments.forEach((segment) => {
          var pg = new google.maps.Polygon({
            paths: segment.coordinates,
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
          });

          pg.setMap(this.map)
          var bounds = new this.google.maps.LatLngBounds();
          for (let i = 0; i < segment.coordinates.length; i++) {
            bounds.extend(segment.coordinates[i]);
          }
          new this.google.maps.Marker({
            position: bounds.getCenter(),
            map: this.map,
            icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflagq.png',
            label: { color: 'white', fontWeight: 'bold', fontSize: '16px', text: segment.geofenceName }
          });
        });
      }

      this.map.addListener("click", (mapsMouseEvent) => {
        const latLng = mapsMouseEvent.latLng.toJSON();
        this.latitude = latLng.lat;
        this.longitude = latLng.lng;
      });
    },

  deleteZone(){
    const item = {id: this.zoneDetail.id}
    this.$emit("deleteZone", item,false)
  },
  closeModal(){
    this.$emit("rowClicked",null, false);
  },
  
  editZoneModal(){
    const item = {id: this.zoneDetail.id}
    this.$emit("editZoneFromDetail",item, false);
  }
  },
  async mounted() {
    this.startLoading()
    if (this.$route.query?.name) { this.geofenceName = this.$route.query.name; }
    const { data } = await FarmService.getLocationData(parseFloat(this.farmId), parseInt(this.locationId));
    this.orgFarm = data;
    this.stopLoading();
    this.latitude = this.orgFarm.lat;
    this.longitude = this.orgFarm.log;
    this.address = this.orgFarm.address;
    this.mapOptions.center.lat = +this.zoneDetail.geofenceCoordinates[0].lat;
    this.mapOptions.center.lng = +this.zoneDetail.geofenceCoordinates[0].log;
    var codes = this.zoneDetail.geofenceCoordinates.map(function (elm) {
      return { lat: parseFloat(elm['lat']), lng: parseFloat(elm['log']) };
    });
    this.parentPolygonCoords = codes;
    if (this.zoneDetail.geofenceCoordinates && this.zoneDetail.geofenceCoordinates.length > 0) {
        var cc = this.zoneDetail.geofenceCoordinates.map((elm) => {
          return { lat: parseFloat(elm['lat']), lng: parseFloat(elm['log']) };
        });
        this.oldSegments.push({ geofenceName: this.zoneDetail.geofenceName, coordinates: cc });
    }


    try {
      const loader = await new Loader({
        apiKey: "AIzaSyBxEppGyQ3YatmT9C8RJjXAh9HsVtpKLh4",
        libraries: ["places", "map"]
      }).load()
        .then((google) => {
          this.google = google;
          this.initializeMap(google);
        })
        .catch(e => {
          console.log('Map', e);
        });
      this.loader = loader;

    } catch (e) {
      console.log(e);
    }
  },

  pageChange(t){
    if (t) this.tableOptions.page = Number(this.tableOptions.page) + 1;
    else this.tableOptions.page = Number(this.tableOptions.page) - 1;
  },
}
</script>

<style>

</style>